//Node imports
import { IEvent,ingenuity, delayedCall, dispatcher, killDelayedCall } from "@quest/base-core";
import { AudioControllerBehavior, FreeGameMetersControllerBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-leopard/dist";
import { SlotEventConstants } from "@quest/slot-core/dist/SlotConstants/SlotEventDispatchers";

//Class imports
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
export class MetersControllerFreeGame extends FreeGameMetersControllerBehavior {

  /**
   * subscribeEvents method overrided to subscribe game end events
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_COIN_PRIZE_FG, this.showCoinPrize, this);
    dispatcher.on(eventDispatchers.UPDATE_JACKPOT_WIN_PRIZE, this.updateJackpotPrize, this);
    dispatcher.on(eventDispatchers.FORCE_STOP_POT_WIN_METER_TICKUP_FG, this.forceStopPotWinMeter, this);
  }

  /**
   * unsubscribeEvents method overrided to unSubscribe game end events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.SHOW_COIN_PRIZE_FG, this.showCoinPrize, this);
    dispatcher.off(eventDispatchers.UPDATE_JACKPOT_WIN_PRIZE, this.updateJackpotPrize, this);
    dispatcher.off(eventDispatchers.FORCE_STOP_POT_WIN_METER_TICKUP_FG, this.forceStopPotWinMeter, this);
  }

  /**
   * showCoinPrize method to show pot prize on win meter
   */
  private showCoinPrize(evt?: IEvent): void {
    const gameCoinValue : number = (ingenuity.parserModel as GameParserModel).getTotalBet() / (ingenuity.parserModel as GameParserModel).getLinesPlayed();
    const totalWinMeter = this.view.getMeterById("freeGameTotalWinValue");
    const prizeValue: number = evt.data * gameCoinValue;
    const currntValu: number = totalWinMeter.getValue();
    totalWinMeter.setCurrencyFormattedValue((prizeValue + currntValu).toString());
    if (evt.data != 0) {
      totalWinMeter.visible = true;
    }
  }

  /**
   * forceStopPotWinMeter method to show complete prize of all pots
   */
  private forceStopPotWinMeter(evt?:IEvent):void{
    const totalWinMeter = this.view.getMeterById("freeGameTotalWinValue");
    // getFSCurrentSpinWin: to add total win till previous spin
    totalWinMeter.setCurrencyFormattedValue(((ingenuity.parserModel as GameParserModel).getPrizePotCreditFG() + (ingenuity.parserModel as GameParserModel).getFSCurrentSpinWin() + (ingenuity.parserModel as GameParserModel).getTotalBaseGameWinAmt()).toString());
            delayedCall("onComplete",500,()=>{
              killDelayedCall("onComplete");
              dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
            })
    if (evt.data != 0) {
      totalWinMeter.visible = true;
    }
  }

  /**
   * This method is use to update the jackpot amount in win meter
   */
  private updateJackpotPrize(evt?: IEvent): void {
    const totalWinMeter = this.view.getMeterById("freeGameTotalWinValue");
    const prizeValue: number = evt.data;
    const currentValue: number = totalWinMeter.getValue();
    totalWinMeter.setCurrencyFormattedValue((prizeValue + currentValue).toString());
    if (evt.data != 0) {
      totalWinMeter.visible = true;
    }
  }

  /**
   * onStartWinTickUp method override play sound
   */
  protected onStartWinTickUp(evt: IEvent): void {
    if (this.model.getIsFgBigWin()) {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);

        // this.winValueMeterFg && (this.winValueMeterFg.startTick(this.model.getThresholdBigWinAmount(), this.model.getIsCredits(), false, SlotConstantsBehavior.WINTICKUP_FG_3_NORMAL_TICK, true, this.tickUpComplete.bind(this)));
        // ingenuity.soundManager.playSound(this.model.getWinMeterTickUpSoundFg(), 1, false);
    }
    else {
          this.showWinTickUpMeter();
        this.winValueMeterFg && (this.winValueMeterFg.startTick(this.model.getCurrentWinAmt(), this.model.getIsCredits(), false, this.model.getWinMeterTickUpDurationFg(), true, this.tickUpComplete.bind(this)));
        (ingenuity.soundManager as AudioControllerBehavior).playSound(this.model.getWinMeterTickUpSoundFg());
    }
    if (ingenuity.soundManager.getSoundInstance(SoundConstant.FREGAME_BGLOOP, "soundList_1")) {
        this.fadeFreeGameBGM();
    }
  }
  /**
     * Method onForceStopWinTickUp overrided to add stageClick OnWinTickup.
     * @param evt 
     */
    protected onForceStopWinTickUp(evt?: IEvent): void {
        if (ingenuity.configData.stageClickOnWinTickup) {
            this.winValueMeterFg.forceStop(this.model.getIsCredits(), false, true, 100, () => {
                this.tickUpComplete();
            });
        } else {
            super.onForceStopWinTickUp(evt);
        }
    }

        /**
     * Method tickUpComplete overrided to add stageClickOnWinTickup.
     */
    protected tickUpComplete(): void {
        ingenuity.configData.stageClickOnWinTickup = false;
        dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_STAGE_CLICK);
        if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, "soundList_1")) {
            (ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, "soundList_1").volume = 1;
            super.tickUpComplete();
        }
    }
 }